import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedCompsModule } from '../shared/shared-comps.module';
import { RouterModule } from '@angular/router';
import { ContactUsComponent } from './contact-us.component';
import { FeedbackComponent } from './feedback/feedback.component';
import { ReactiveFormsModule,FormsModule  } from '@angular/forms';


@NgModule({
	declarations: [
		ContactUsComponent,
		FeedbackComponent
	],
	imports: [
		CommonModule,
		SharedCompsModule,
		RouterModule,
		SharedCompsModule,
		ReactiveFormsModule,
		FormsModule
	],
	exports : [
		ContactUsComponent
	]
})
export class ContactUsModule { }
